import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useContext, useEffect } from 'react';
import ReactModal from 'react-modal';
import { useScrollbarWidth } from '@nicollet/common';
import { AppContext } from '../AppContext/index.js';
import { CellModalHeader } from '../CellModalHeader/index.js';
import { PopoverInModalStyles, StyledReactModal, overlayStyles, ContentWrapper } from './styles.js';

const BaseModalFloat = ({
  children,
  'data-test': testId,
  headingText,
  iconButtonCloseOnClick,
  isAuto,
  isOpen,
  // react-modal prop
  isShort,
  onAfterClose,
  // react-modal prop
  onAfterOpen,
  // react-modal prop
  onRequestClose,
  // react-modal prop
  portalClassName,
  renderCellButton,
  rootNodeId
}) => {
  var _a;

  const {
    scrollbarWidth
  } = useScrollbarWidth();
  const {
    rootNodeId: rootId
  } = useContext(AppContext.Context);
  const modalRootId = (_a = rootId !== null && rootId !== void 0 ? rootId : rootNodeId) !== null && _a !== void 0 ? _a : 'root';
  const isBrowser = typeof window !== 'undefined';
  const setModalRoot = isBrowser ? () => ReactModal.setAppElement(document.getElementById(modalRootId)) : () => {};
  useEffect(setModalRoot, [setModalRoot]);
  return jsxs(Fragment, {
    children: [jsx(PopoverInModalStyles, {
      scrollbarWidth: scrollbarWidth
    }, void 0), jsxs(StyledReactModal, Object.assign({
      data: {
        test: testId
      },
      isAuto: isAuto,
      isOpen: isOpen,
      isShort: isShort,
      onAfterClose: onAfterClose,
      onAfterOpen: onAfterOpen,
      onRequestClose: onRequestClose,
      portalClassName: portalClassName,
      style: overlayStyles
    }, {
      children: [jsx(CellModalHeader, {
        closeButtonOnClick: iconButtonCloseOnClick,
        "data-test": "modalHeader",
        headingText: headingText
      }, void 0), jsx(ContentWrapper, {
        children: children
      }, void 0), renderCellButton]
    }), void 0)]
  }, void 0);
};

BaseModalFloat.displayName = 'BaseModalFloat';

export { BaseModalFloat };
